
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3 4.646a1.504 1.504 0 011.504-1.503h14.99A1.503 1.503 0 0121 4.646v14.991a1.505 1.505 0 01-1.505 1.506H4.504A1.503 1.503 0 013 19.638V4.646zm7.125 5.36h2.437v1.223c.352-.703 1.252-1.336 2.604-1.336 2.593 0 3.208 1.401 3.208 3.973v4.763H15.75v-4.178c0-1.464-.352-2.29-1.245-2.29-1.24 0-1.756.89-1.756 2.29v4.178h-2.624v-8.624zm-4.5 8.511h2.624V9.893H5.625V18.517zm3-11.437a1.688 1.688 0 11-3.375.074 1.688 1.688 0 013.375-.074z","fill":"#ABAFB5"}})])
          )
        }
      }
    